module.exports = __webpack_public_path__ + "static/media/Close_Icon1.6f59c74b.svg";